import { type FC, type ReactNode } from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";

export interface MovedLocationTemplateProps {
	readonly icon?: ReactNode;
	readonly header: ReactNode;
	readonly body: ReactNode;
	readonly onActionClick?: () => void;
	readonly actionLabel?: ReactNode;
	readonly minHeight?: string | number;
}

export const MovedLocationTemplate: FC<MovedLocationTemplateProps> = ({
	icon,
	header,
	body,
	onActionClick,
	actionLabel = "Take me there",
	minHeight = "calc(100vh - 240px)",
}) => {
	return (
		<Paper
			elevation={0}
			sx={{
				alignItems: "center",
				border: (theme) => `1px solid ${theme.palette.divider}`,
				borderRadius: 1.5,
				backgroundColor: "white",
				display: "flex",
				justifyContent: "center",
				minHeight,
				padding: { md: 6, xs: 4 },
			}}
		>
			<Stack spacing={4} sx={{ alignItems: "center", textAlign: "center" }}>
				{icon !== undefined && <Box>{icon}</Box>}

				<Stack spacing={2}>
					<Typography variant="h2">{header}</Typography>
					<Typography color="text.secondary">{body}</Typography>
				</Stack>

				{onActionClick !== undefined && (
					<Button variant="contained" onClick={onActionClick}>
						{actionLabel}
					</Button>
				)}
			</Stack>
		</Paper>
	);
};
